
import { fetchSiteFinancialStatus } from 'dashboard/actions/site-financial-status/site-financial-status.actions';

import template from './financial-status-widget-content.html';

const mapStateToThis = ({ siteFinancialStatus }) => {
  const { data, isLoading } = siteFinancialStatus;

  return {
    data,
    isLoading,
  };
};

const mapDispatchToThis = {
  fetchSiteFinancialStatus,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class FinancialStatusWidgetContentController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onChanges({ retailerId }) {
    if (retailerId.currentValue) this.fetchSiteFinancialStatus(retailerId.currentValue);
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class FinancialStatusWidgetContentComponent {
  constructor() {
    this.bindings = {
      retailerId: '<',
    };
    this.template = template;
    this.controller = FinancialStatusWidgetContentController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/financial-status/components/financial-status-widget-content-component.js